import React from 'react';
import { ShoppingBag, Plus, Edit2, Trash2, MessageSquare } from 'lucide-react';

const RecommendationsTab = ({ recommendations, onAdd, onEdit, onDelete }) => (
  <div>
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--space-l)' }}>
      <button
        onClick={onAdd}
        data-testid="add-recommendation-btn"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--space-s)',
          padding: '10px 16px',
          backgroundColor: 'var(--black)',
          color: 'var(--white)',
          border: 'none',
          fontFamily: 'var(--font-body)',
          fontSize: '0.8125rem',
          cursor: 'pointer'
        }}
      >
        <Plus size={16} />
        Добавить рекомендацию
      </button>
    </div>

    {recommendations.length === 0 ? (
      <div style={{ textAlign: 'center', padding: 'var(--space-xxl)', backgroundColor: 'var(--white)', border: '1px solid var(--soft-gray)' }}>
        <ShoppingBag size={48} style={{ color: 'var(--light-gray)', marginBottom: 'var(--space-l)' }} />
        <p style={{ fontFamily: 'var(--font-display)', fontSize: '1.25rem' }}>Нет рекомендаций</p>
      </div>
    ) : (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'var(--space-l)' }}>
        {recommendations.map((rec) => (
          <div key={rec.id} style={{ backgroundColor: 'var(--white)', border: '1px solid var(--soft-gray)', overflow: 'hidden', position: 'relative' }}>
            {/* Edit and Delete buttons */}
            <div style={{ position: 'absolute', top: '8px', right: '8px', display: 'flex', gap: '4px', zIndex: 2 }}>
              <button
                onClick={() => onEdit(rec)}
                style={{
                  padding: '6px',
                  backgroundColor: 'rgba(255,255,255,0.9)',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                <Edit2 size={14} style={{ color: 'var(--mid-gray)' }} />
              </button>
              <button
                onClick={() => onDelete(rec.id)}
                style={{
                  padding: '6px',
                  backgroundColor: 'rgba(255,255,255,0.9)',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                <Trash2 size={14} style={{ color: '#ef4444' }} />
              </button>
            </div>
            {rec.image_url && (
              <div style={{ height: '180px', overflow: 'hidden', backgroundColor: 'var(--cream)' }}>
                <img src={rec.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            )}
            <div style={{ padding: 'var(--space-m)' }}>
              <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.875rem', marginBottom: 'var(--space-m)' }}>
                {rec.description}
              </p>
              {rec.request_id && (
                <div style={{
                  marginBottom: 'var(--space-m)',
                  padding: '6px 10px',
                  backgroundColor: '#3b82f615',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '0.75rem',
                  color: '#3b82f6'
                }}>
                  <MessageSquare size={12} />
                  По запросу клиента
                </div>
              )}
              <a
                href={rec.product_url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '8px 16px',
                  backgroundColor: 'var(--cream)',
                  color: 'var(--charcoal)',
                  textDecoration: 'none',
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.75rem'
                }}
              >
                Открыть ссылку
              </a>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default RecommendationsTab;
